/**
 * @function formatNumber
 * @param {Number} number - Finite number to be formatted
 * @returns {String} A string with formatted number in the format of ii iii iii,dd - where i is
 * an integer part of number, and d is decimal part, or number parameter if it is not actually a number.
 */

interface Options {
    maximumFractionDigits?: number;
    minimumFractionDigits?: number;
    fractionDelimiter?: string;
}

const formatNumber = (
    value: number | string,
    { maximumFractionDigits = 2, minimumFractionDigits, fractionDelimiter = ',' }: Options = {}
): string => {
    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) {
        return String(value);
    }

    return numberValue
        .toLocaleString('en-US', { maximumFractionDigits, minimumFractionDigits })
        .replace(/,/g, ' ')
        .replace('.', fractionDelimiter);
};

const UNKNOWN_RATING_VALUE = '–';

export const presentRatingValue = ({
    value,
    fractionDigits,
}: {
    value: number | null;
    fractionDigits?: number;
}): string => {
    if (!value) {
        return UNKNOWN_RATING_VALUE;
    }

    return formatNumber(value, {
        fractionDelimiter: '.',
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
    });
};
